import { useEffect } from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import Head from 'next/head';
import styles from 'styles/pages/terms-privacy.module.scss';
import AccessibilityLocale from 'locale/en/accessibility.json';
import MiscLocale from 'locale/en/misc.json';
import { getContentSection } from 'lib/contentful/get-content-section';
import { getContentField } from 'lib/contentful/get-content-field';
import { pageReplaced } from 'lib/utils/page-replaced';
import { createMarkup } from 'lib/utils/create-markup';
import { getContentfulDataDirect } from 'lib/contentful/get-contentful-data-direct';

const PageData = {
  page_type: 'default',
  page_class: 'page-accessibility',
  page_name: AccessibilityLocale.page_name,
  page_title: AccessibilityLocale.page_title,
  page_description: AccessibilityLocale.page_desc,
};

const PageHead = () => (
  <Head>
    <title>{`${MiscLocale.brand} • ${PageData.page_title}`}</title>
    <meta name='description' content={PageData.page_description} />
  </Head>
);

const PageAccessibility = (props) => {
  const { page } = props;
  const section = getContentSection({
    data: page,
    include: 'Accessibility - Section',
  })?.shift();

  const content = getContentField({
    data: section,
    title: 'Accessibility - Body',
  });

  useEffect(() => {
    pageReplaced(PageData);
  });

  return (
    <>
      <PageHead />
      <div className={styles.container}>
        <div className={styles.aside}>
          {AccessibilityLocale.accessibility_statement}
        </div>
        <div className={styles['sections-list']}>
          <section
            dangerouslySetInnerHTML={createMarkup(
              documentToHtmlString(content).replace(/\n/g, '<br/>'),
            )}
          />
        </div>
      </div>
    </>
  );
};

export async function getStaticProps() {
  const accessibilityQuery = {
    content_type: 'page',
    'fields.slug': 'accessibility',
    include: 10,
  };
  const accessibilityPayload =
    await getContentfulDataDirect(accessibilityQuery);

  const props = {
    page: accessibilityPayload.items?.pop()?.fields || null,
  };

  return {
    props,
    revalidate: 60 * 60, // One hour in seconds
  };
}

export default PageAccessibility;
